const originalFetch = window.fetch;

const LIMITED = {
  //The 5-Day Reset: Limited Edition
  "product": 40517350064328,
  "gift": 43896239423688,
};
const SIGNATURE ={
  //The 5-Day Reset: Signature Edition
  "product": 41742830829768,
  "gift": 52910801977709,
}

window.fetch = async function (input, init) {
  const inputUrl = typeof input === "string" ? input : input?.url;
  const method = init?.method || (typeof input !== "string" && input?.method);
  const methodUpper = method ? method.toUpperCase() : "";
  const isAdd = typeof inputUrl === "string" && inputUrl.includes("/cart/add.js");
  const isChange =
    (typeof inputUrl === "string" && inputUrl.includes("/cart/change.js")) ||
    (typeof inputUrl === "string" &&
      inputUrl.includes("/cart/update.js") &&
      methodUpper === "POST");
  const isClear =
    typeof inputUrl === "string" &&
    inputUrl.includes("/cart/clear.js") &&
    methodUpper === "POST";
  const normalizedInit = enrichSaleExclusionProperty(inputUrl, methodUpper, init);
  const response = await originalFetch(input, normalizedInit);

  if (isAdd || isChange || isClear) {
    try {
      const cloned = response.clone();
      const data = await cloned.json();

      let action = "update";
      if (isAdd) action = "add";
      else if (isChange) {
        const body = init?.body;
        let parsedBody;
        try {
          parsedBody = typeof body === "string" ? JSON.parse(body) : body;
          if (parsedBody?.quantity === 0) action = "delete";
        } catch {}
      } else if (isClear) {
        action = "clear";
      }

      document.dispatchEvent(
        new CustomEvent("customCart:event", {
          detail: {
            action,
            cart: data,
          },
        })
      );
    } catch (err) {
      console.error("Error:", err);
    }
  }

  return response;
};

function shouldAddSaleExclusion(variantId) {
  const numericVariantId = Number(variantId);
  return (
    numericVariantId === LIMITED.product || numericVariantId === SIGNATURE.product
  );
}

function addSaleExclusionToLineItem(item) {
  if (!item || !shouldAddSaleExclusion(item.id)) return item;

  return {
    ...item,
    properties: {
      ...(item.properties || {}),
      _sale_exclusion: true,
    },
  };
}

function enrichSaleExclusionProperty(url, method, init) {
  const isCartAdd = typeof url === "string" && url.includes("/cart/add.js");
  const isPost = method === "POST";

  if (!isCartAdd || !isPost || !init?.body) {
    return init;
  }

  if (typeof init.body === "string") {
    return enrichJsonBodySaleExclusion(init);
  }

  if (init.body instanceof FormData) {
    return enrichFormDataBodySaleExclusion(init);
  }

  if (init.body instanceof URLSearchParams) {
    return enrichUrlEncodedBodySaleExclusion(init);
  }

  return init;
}

function enrichJsonBodySaleExclusion(init) {
  try {
    const parsedBody = JSON.parse(init.body);
    let hasChanges = false;
    let nextBody = parsedBody;

    if (Array.isArray(parsedBody.items)) {
      const nextItems = parsedBody.items.map((item) => {
        const updatedItem = addSaleExclusionToLineItem(item);
        if (updatedItem !== item) hasChanges = true;
        return updatedItem;
      });
      nextBody = { ...parsedBody, items: nextItems };
    } else {
      const updatedItem = addSaleExclusionToLineItem(parsedBody);
      if (updatedItem !== parsedBody) hasChanges = true;
      nextBody = updatedItem;
    }

    if (!hasChanges) return init;

    return {
      ...init,
      body: JSON.stringify(nextBody),
    };
  } catch {
    return init;
  }
}

function enrichFormDataBodySaleExclusion(init) {
  const formData = init.body;
  const enriched = new FormData();
  let hasChanges = false;
  let shouldTagSingleItem = false;
  const itemIndexesToTag = [];

  formData.forEach((value, key) => {
    enriched.append(key, value);

    if (key === "id" && shouldAddSaleExclusion(value)) {
      shouldTagSingleItem = true;
    }

    const itemIdMatch = key.match(/^items\[(\d+)\]\[id\]$/);
    if (itemIdMatch && shouldAddSaleExclusion(value)) {
      itemIndexesToTag.push(itemIdMatch[1]);
    }
  });

  if (
    shouldTagSingleItem &&
    !formData.has("properties[_sale_exclusion]")
  ) {
    enriched.append("properties[_sale_exclusion]", "true");
    hasChanges = true;
  }

  itemIndexesToTag.forEach((index) => {
    const key = `items[${index}][properties][_sale_exclusion]`;
    if (!formData.has(key)) {
      enriched.append(key, "true");
      hasChanges = true;
    }
  });

  if (!hasChanges) return init;

  return {
    ...init,
    body: enriched,
  };
}

function enrichUrlEncodedBodySaleExclusion(init) {
  const params = init.body;
  const enriched = new URLSearchParams(params.toString());
  let hasChanges = false;

  const singleId = params.get("id");
  if (
    shouldAddSaleExclusion(singleId) &&
    !params.has("properties[_sale_exclusion]")
  ) {
    enriched.set("properties[_sale_exclusion]", "true");
    hasChanges = true;
  }

  const itemIndexesToTag = [];
  params.forEach((value, key) => {
    const itemIdMatch = key.match(/^items\[(\d+)\]\[id\]$/);
    if (itemIdMatch && shouldAddSaleExclusion(value)) {
      itemIndexesToTag.push(itemIdMatch[1]);
    }
  });

  itemIndexesToTag.forEach((index) => {
    const key = `items[${index}][properties][_sale_exclusion]`;
    if (!params.has(key)) {
      enriched.set(key, "true");
      hasChanges = true;
    }
  });

  if (!hasChanges) return init;

  return {
    ...init,
    body: enriched,
  };
}

async function getCart() {
  try {
    const response = await fetch("/cart.js");
    const cart = await response.json();
    return cart;
  } catch (e) {
    console.error("Error fetching cart:", e);
    return null;
  }
}

document.addEventListener("customCart:event", (event) => {
  console.log("Product added:", event.detail.cart);
  let cart = event.detail.cart;
  const giftJustAdded = cart.items_added?.some(
    (item) =>{
      if (item.id === LIMITED.gift || item.id === SIGNATURE.gift) {
        return true;
      }
      return false;
    } 
  );
  getCart().then(async (cart) => {
    if (!cart) return;

    const signatureGiftClamped = await clampGiftToResetCount(
      cart.items,
      SIGNATURE.product,
      SIGNATURE.gift
    );
    const limitedGiftClamped = await clampGiftToResetCount(
      cart.items,
      LIMITED.product,
      LIMITED.gift
    );

    if (signatureGiftClamped || limitedGiftClamped) {
      cart = await getCart();
      if (!cart) return;
    }

    //if theres a reset in the cart, ensure theres one gift
    //if theres at least one reset and one gift returns true
    const { totalSignature, totalLimited } = checkResetCount(cart.items);
    const { totalSignatureGift, totalLimitedGift } = checkGiftCount(cart.items);
    console.log('THE CART HAS BEEN UPDATED', { totalSignature, totalLimited, totalSignatureGift, totalLimitedGift, giftJustAdded });
    //adding gift logic
    if (totalSignature > totalSignatureGift) {
      //add gift to cart
      if (!giftJustAdded) addGift(SIGNATURE.gift);
    } else if (totalLimited > totalLimitedGift
    ) {
      //add gift to cart
      if (!giftJustAdded) addGift(LIMITED.gift);
    } 
    applyCheckoutAvailabilityFromTotals(
      totalSignature,
      totalLimited,
      totalSignatureGift,
      totalLimitedGift
    );
  });
});

initCheckoutValidationGuard();

async function isCheckoutCartValid() {
  const cart = await getCart();
  if (!cart) return false;

  const { totalSignature, totalLimited } = checkResetCount(cart.items);
  const { totalSignatureGift, totalLimitedGift } = checkGiftCount(cart.items);

  return (
    totalSignature === totalSignatureGift &&
    totalLimited === totalLimitedGift
  );
}

function initCheckoutValidationGuard() {
  let checkoutValidationInProgress = false;
  const blockMessage =
    "Please wait a second while we finish updating your cart before checkout.";

  const tryCheckoutNavigation = async (checkoutUrl, checkoutElement) => {
    if (checkoutValidationInProgress) return;
    checkoutValidationInProgress = true;

    if (checkoutElement) {
      checkoutElement.classList.add("btn--loading");
      checkoutElement.setAttribute("aria-disabled", "true");
    }

    try {
      const canCheckout = await isCheckoutCartValid();
      applyCheckoutAvailability(canCheckout);

      if (!canCheckout) {
        alert(blockMessage);
        return;
      }

      window.location.assign(checkoutUrl || "/checkout");
    } finally {
      checkoutValidationInProgress = false;
      if (checkoutElement) {
        checkoutElement.classList.remove("btn--loading");
        checkoutElement.removeAttribute("aria-disabled");
      }
    }
  };

  const interceptCheckoutLink = (event) => {
    const checkoutLink = event.target.closest(
      'a[href="/checkout"], a[href^="/checkout?"], .cart-drawer-checkout-btn[href^="/checkout"]'
    );
    if (!checkoutLink) return;

    if (
      checkoutLink.classList.contains("disabled") ||
      checkoutLink.getAttribute("aria-disabled") === "true"
    ) {
      return;
    }

    event.preventDefault();
    tryCheckoutNavigation(checkoutLink.getAttribute("href"), checkoutLink);
  };

  document.addEventListener("pointerdown", interceptCheckoutLink, true);
  document.addEventListener("touchstart", interceptCheckoutLink, true);
  document.addEventListener("click", interceptCheckoutLink, true);

  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const checkoutButton = form.querySelector('[name="checkout"], .cart__checkout');
      if (!checkoutButton) return;

      const termsCheckbox = form.querySelector(".cart__terms-checkbox");
      if (termsCheckbox && !termsCheckbox.checked) {
        return;
      }

      event.preventDefault();
      tryCheckoutNavigation("/checkout", checkoutButton);
    },
    true
  );

  refreshCheckoutAvailability();
  window.setInterval(refreshCheckoutAvailability, 1000);
}

async function refreshCheckoutAvailability() {
  const canCheckout = await isCheckoutCartValid();
  applyCheckoutAvailability(canCheckout);
}

function applyCheckoutAvailabilityFromTotals(
  totalSignature,
  totalLimited,
  totalSignatureGift,
  totalLimitedGift
) {
  const canCheckout =
    totalSignature === totalSignatureGift &&
    totalLimited === totalLimitedGift;
  applyCheckoutAvailability(canCheckout);
}

function applyCheckoutAvailability(canCheckout) {
  document
    .querySelectorAll(".cart__checkout, .cart-drawer-checkout-btn")
    .forEach((element) => {
      const isButton = element.tagName === "BUTTON";

      if (canCheckout) {
        element.classList.remove("disabled");
        element.removeAttribute("aria-disabled");
        if (isButton) element.disabled = false;
      } else {
        element.classList.add("disabled");
        element.setAttribute("aria-disabled", "true");
        if (isButton) element.disabled = true;
      }
    });

  document.querySelectorAll(".additional-checkout-buttons").forEach((element) => {
    element.style.display = canCheckout ? "" : "none";
    element.setAttribute("aria-hidden", canCheckout ? "false" : "true");
  });
}

function checkGiftCount(items) {
  let totalSignatureGift = 0;
  let totalLimitedGift = 0;

  items?.forEach((item) => {
    if (item.id === SIGNATURE.gift) {
      // Cambiar variant_id por id
      totalSignatureGift += item.quantity;
    }
    if (item.id === LIMITED.gift) {
      // Cambiar variant_id por id
      totalLimitedGift += item.quantity;
    }
  });

  return { totalSignatureGift, totalLimitedGift };
}

function getLineItemsByVariantId(items, variantId) {
  return (items || []).filter((item) => item.id === variantId);
}

function getTotalQtyByVariantId(items, variantId) {
  return getLineItemsByVariantId(items, variantId).reduce(
    (total, item) => total + item.quantity,
    0
  );
}

async function clampGiftToResetCount(items, productVariantId, giftVariantId) {
  const productQty = getTotalQtyByVariantId(items, productVariantId);
  const giftLines = getLineItemsByVariantId(items, giftVariantId);
  const giftQty = giftLines.reduce((total, item) => total + item.quantity, 0);

  if (giftQty <= productQty) return false;

  let overflow = giftQty - productQty;
  for (const line of giftLines) {
    if (overflow <= 0) break;

    const reducedBy = Math.min(line.quantity, overflow);
    const nextQty = line.quantity - reducedBy;
    await deleteGift(line.key, nextQty);
    overflow -= reducedBy;
  }

  return true;
}

function checkResetCount(items) {
  let totalSignature = 0;
  let totalLimited = 0;
  items?.forEach((item) => {
    if (SIGNATURE.product === item.id) {
      // Cambiar variant_id por id
      totalSignature += item.quantity;
    }
    if (LIMITED.product === item.id) {
      // Cambiar variant_id por id
      totalLimited += item.quantity;
    }
  });
  return { totalSignature, totalLimited };
}

function handleDeleteGift(items, gift_id) {
  items.forEach((el) => {
    if (el.id == gift_id) {
      // Cambiar variant_id por id
      deleteGift(el.key, 0);
    }
  });
}
function addGift(giftId = GIFT_VARIANT1) {
  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: giftId,
      quantity: 1,
      properties: {
        _tier: "SpringShed26",
        _sale_exclusion: true,

      },
    }),
  })
    .then((res) => res.json())
    .then((data) => {
      console.log("Gift added:", data);
    })
    .catch((err) => {
      console.error("Error adding gift:", err);
    });
}

function deleteGift(itemKey, newQty) {
  return fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      id: itemKey,
      quantity: newQty,
    }),
  })
    .then((res) => res.json())
    .then((cart) => {
      console.log("Gift removed:", cart);

      // Refrescar el cart drawer
      refreshCartDrawer();
    })
    .catch((err) => {
      console.error("Error deleting gift:", err);
    });
}
